import { render, staticRenderFns } from "./ConfidenceLevel.vue?vue&type=template&id=04c908d8&scoped=true&"
import script from "./ConfidenceLevel.vue?vue&type=script&lang=js&"
export * from "./ConfidenceLevel.vue?vue&type=script&lang=js&"
import style0 from "./ConfidenceLevel.vue?vue&type=style&index=0&id=04c908d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c908d8",
  null
  
)

export default component.exports